/* KiddieWink: reveal-on-scroll and the "Read more" toggle. No library needed. */
(function () {
  if (window.__kwUi) return;
  window.__kwUi = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var inEditor = window.Shopify && window.Shopify.designMode;

    /* reveal on scroll */
    var items = document.querySelectorAll('.kw-reveal');
    if (items.length && !inEditor && 'IntersectionObserver' in window) {
      document.documentElement.classList.add('kw-js');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('kw-in');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
      items.forEach(function (el) { io.observe(el); });
    }

    /* read more: text is fully in the page, only its height is limited */
    document.querySelectorAll('.kw-seo').forEach(function (box) {
      var clip = box.querySelector('.kw-seo-clip');
      var btn = box.querySelector('.kw-seo-more');
      if (!clip || !btn || inEditor) return;
      if (clip.scrollHeight < 380) return;
      box.classList.add('kw-clamped');
      btn.addEventListener('click', function () {
        var open = box.classList.toggle('kw-open');
        box.classList.toggle('kw-clamped', !open);
        btn.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  });
})();
